import { generateLink2 } from "@/api/communal";
import { login, } from '@/api/xibSaveMoney.js'
import { Toast } from 'vant'

// 天数键值映射
export const dayMap = {
  0: 3,
  1: 10,
  2: 30,
  3: 30,
}

// 跳转到微信领取奖品
export function toWeChatClaim (recordId) {
  let urlToken = sessionStorage.getItem('xiameBankAscendGoldToken')
  const url = `${process.env.VUE_APP_H5_PREFIX_URL}ydsh-ph-h5-bankv3/XiameBankAscendGoldWxCollecting?recordId=${recordId}&urlToken=${urlToken}`
  console.log(url);
  // window.location.href = url
  generateLink2({
    link: encodeURIComponent(url)
  }).then(res => {
    window.location.href = res.data.urlLink
  })
}
// 跳转如e宝首页（行方页面）
export function toRueBaoPage () {
  const url = `${process.env.VUE_APP_XIAMENBANK_PREFIX_URL}v4-std/finance/index.html#/finance/finance-ryb?hasCheckHold=1&xibpopup=true`
  console.log(url);
  window.location.href = url
}
// 跳转其他活动首页（行方页面）
export function toEventHomePage () {
  const url = `${process.env.VUE_APP_XIAMENBANK_PREFIX_URL}v4-std/activity-center/index.html#/activity-center/index`
  console.log(url);
  window.location.href = url
}

// 登录接口 ,参数（vue实例）
export function loginFun (that) {
  return new Promise((resolve, reject) => {
    let { token } = that.$route.query
    console.log(that.$route.query);
    if (!token) {
      return Toast('请携带token参数')
    }
    login({ token: token }).then(async res => {
      if (res.code === 0) {
        sessionStorage.setItem('xiameBankAscendGoldToken', res.data.token)
        resolve()
      } else {
        that.loginErrorMsg = res.message
        if (res.message === '您不符合活动资格') {
          that.notEligibleShow()
        } else {
          Toast.fail(res.message)
        }
        reject(res.mesmessages)
      }
    })
  })

}
// 页面图片预先加载
export const preFetchImg = () => {
  let imgs = [
    require("@/assets/imgs/xiamenBankAscendGold/ascend_gold2.png"),
    require("@/assets/imgs/xiamenBankAscendGold/ascend_gold18.png"),
    require("@/assets/imgs/xiamenBankAscendGold/ascend_gold20.png"),
    require("@/assets/imgs/xiamenBankAscendGold/ascend_gold22.png"),
    require("@/assets/imgs/xiamenBankAscendGold/ascend_gold29.png"),
    require("@/assets/imgs/xiamenBankAscendGold/ascend_gold30.png"),
    require("@/assets/imgs/xiamenBankAscendGold/ascend_gold31.png"),
    require("@/assets/imgs/xiamenBankAscendGold/ascend_gold34.png"),
    require("@/assets/imgs/xiamenBankAscendGold/ascend_gold35.png"),
    require("@/assets/imgs/xiamenBankAscendGold/ascend_gold40.png"),
    require("@/assets/imgs/xiamenBankAscendGold/ascend_gold41.png"),

  ]
  for (let img of imgs) {
    let image = new Image()
    image.src = img
    image.onload = () => { }
  }
}